enum ManageCourseActiveButtonEnum{
    publication=1,
    tasks=2,
    questions=3
}

export default ManageCourseActiveButtonEnum